module.exports = __webpack_public_path__ + "hair-on-fire.bfb84d.svg";